import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";
import ResmedSignIn from "src/containers/SignInPage/ResmedSignIn";

import FormHeaderSection from "@components/FormHeaderSection";

import SleepCard from "@containers/Cards/SleepCard";
import LoginForm from "@containers/Forms/LoginForm";

import { useQuery } from "../../services/utils";

const resmedLogoPath = "/assets/external-logos/resmed-logo-large.svg";

const Login = () => {
  const history = useHistory();
  const social = useQuery().get("social");

  if (social) return <ResmedSignIn source="login" />;

  return (
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <SleepCard />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormHeaderSection
            title="Welcome Back"
            description="New to Ognomy?"
            link="Create account"
            path="/"
          />

          <LoginForm />

          <Typography variant="h5" fontSize={32} fontWeight={600} pb={1}>
            Social Logins
          </Typography>

          <Button
            fullWidth
            sx={{
              padding: 1,
              borderRadius: 1,
              backgroundColor: "background.light",
              fontSize: "1rem",
            }}
            onClick={() => history.push("/resmed/login")}
          >
            <img
              src={resmedLogoPath}
              alt="Resmed Logo"
              style={{ width: "90px", marginLeft: "10px" }}
            />
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Login;
